/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/lodash.js"/>
/// <reference path="/js/global.js"/>

(function($, _) {
  var ns = nspace("ccc.botDetection");

  ns.Detection = function(id) {
    this.id = id;
    _.bindAll(this, "detectBot");
  };

  (function(proto) {
    proto.detectBot = function(millis) {
      var self = this;
      setTimeout(function() {
        var result =
          Math.log(
            Math.log(Math.pow(Math.PI * Math.E, Math.pow(Math.PI, Math.E)))
          ) / Math.LN10;
        $("#" + self.id).val(result);
      }, millis);
    };
  })(ns.Detection.prototype);
})(jQuery, _);
